import React, { useEffect } from 'react';

const PasswordWarning = ({ passwordExpireLeft, handleOpenModal }) => {
  useEffect(() => {
    // Auto-open modal if password expired
    if (passwordExpireLeft !== null && passwordExpireLeft < 0) {
      handleOpenModal(null, 'change-password');
    }
  }, [passwordExpireLeft, handleOpenModal]);

  if (passwordExpireLeft === null) return null;

  // Expired password
  if (passwordExpireLeft < 0) {
    return (
      <p className="text-danger text-center fw-bold">
        <marquee>
          Your password has expired! The change password modal will open
          automatically.
        </marquee>
      </p>
    );
  }

  // Expiring soon (less than 15 days)
  if (passwordExpireLeft < 15) {
    return (
      <p className="text-danger text-center fw-bold">
        <marquee>
          Your password will expire soon, it only remains {passwordExpireLeft}{' '}
          days, please{' '}
          <a href="/" onClick={(e) => handleOpenModal(e, 'change-password')}>
            change
          </a>{' '}
          it before it expires.
        </marquee>
      </p>
    );
  }

  // Password fine, no warning
  return null;
};

export default PasswordWarning;
